module.exports = __webpack_public_path__ + "img/user_profile_bg.8bc37a7c.jpg";